import { Report, UtcTime, ReportType } from 'types';
import { setReportType } from './reportType';

export const createNewReport = (owner: string, created: UtcTime, name: string, reportType: ReportType, shared: boolean): Report =>
    setReportType({
        reportId: 0,
        name,
        owner,
        reportType: null as any, // tslint:disable-line:no-any
        created,
        shared,
        scheduled: false,
        // tslint:disable
        settings:
            '<Report Output="Graph">' +
                '<StartEnd Start="-1440" End="-1" />' +
                '<TimeOfDay Start="0" End="1440" />' +
                '<Distribution>' +
                    '<Email Disabled="True"/>' +
                    '<File Disabled="True">' +
                        '<FileName UseDefault="True" UseUTCDateTime="False" Format="%rn_%YYYY%MM%DD_%HH%mm%ss_%fff"/>' +
                    '</File>' +
                '</Distribution>' +
                '<Schedule Enabled="False">' +
                    '<DataInclusion Start="0" End="1439" />' +
                    '<Hourly Frequency="1"/>' +
                '</Schedule>' +
                '<Graph Size="800,600" Type="Line"/>' +
            '</Report>',
        // tslint:enable
    }, reportType)
;



// WEBPACK FOOTER //
// ./src/logic/reports/createNewReport.ts